import { render } from "./AudioSection.vue?vue&type=template&id=df3bcb24"
import script from "./AudioSection.vue?vue&type=script&lang=js"
export * from "./AudioSection.vue?vue&type=script&lang=js"

import "./AudioSection.vue?vue&type=style&index=0&id=df3bcb24&lang=sass"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__